// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/screens/Team/index.css
// module id = 2389
// module chunks = 0